export default __webpack_public_path__ + "static/media/element_spec_53.061b6c7a.webp";